import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Link } from "react-router";
import MyClientIcon from "./MyClientIcon";
import "./MyClientTable.style.scss";

class MyClientTable extends Component {
  state = {
    openedPortfolios: [],
    myClientsDataGroupByClientID: {},
  };

  componentDidMount() {
    const { data } = this.props;
    if (data) {
      let myClientsDataGroupByClientID = _.groupBy(data, "client_id");
      this.setState(
        {
          myClientsDataGroupByClientID,
        },
        () => console.log(myClientsDataGroupByClientID)
      );
    }
  }
  portfolioShowHandler = (id) => {
    if (!id) return;
    const { openedPortfolios } = this.state;
    if (openedPortfolios.includes(id)) {
      let filtered = openedPortfolios.filter((e) => e !== id);
      this.setState({
        openedPortfolios: filtered,
      });
    } else {
      this.setState({
        openedPortfolios: [...openedPortfolios, id],
      });
    }
  };
  render() {
    const { openedPortfolios, myClientsDataGroupByClientID } = this.state;
    const { iconHandler, data } = this.props;
    return (
      <div className="myClientTable">
        <div className="myClientTable__heading">
          <div></div>
          <div>Name</div>
          <div>age</div>
          <div>zip code</div>
          <div>annual income</div>
          <div>net worth</div>
          <div>Risk Capacity</div>
          <div>Risk Preference</div>
          <div></div>
        </div>
        <div className="myClientTable__content">
          {data &&
            data.length &&
            _.uniqBy(data, "client_id").map((list, i) => (
              <Fragment key={i}>
                <div className="myClientTable__content__cell">
                  <div>
                    {openedPortfolios.includes(
                      `${list["scenario_name"]}_${list["client_id"]}`
                    ) ? (
                      <i
                        className="fa fa-sort-down"
                        onClick={() =>
                          this.portfolioShowHandler(
                            `${list["scenario_name"]}_${list["client_id"]}`
                          )
                        }
                      ></i>
                    ) : (
                      <i
                        className="fa fa-play"
                        onClick={() =>
                          this.portfolioShowHandler(
                            `${list["scenario_name"]}_${list["client_id"]}`
                          )
                        }
                      ></i>
                    )}
                  </div>
                  <div>{list["client_profile"]["client_name"]}</div>
                  <div>
                    {list["client_profile"]["risk_profile"]["input"].age}
                  </div>
                  <div>
                    {
                      list["client_profile"]["risk_profile"]["input"][
                        "geo-zip-code"
                      ]
                    }
                  </div>
                  <div>
                    {
                      list["client_profile"]["risk_profile"]["input"][
                        "financial-income"
                      ]
                    }
                  </div>
                  <div>
                    {
                      list["client_profile"]["risk_profile"]["input"][
                        "financial-net-worth-override"
                      ]
                    }
                  </div>
                  <div>
                    {`${list["client_profile"]["risk_profile"]["riskCapacityDescription"]} (${list["client_profile"]["risk_profile"]["riskCapacityScore"]})`}
                  </div>
                  <div>
                    {`${list["client_profile"]["risk_profile"]["riskPreferenceDescription"]} (${list["client_profile"]["risk_profile"]["riskPreferenceScore"]})`}
                  </div>
                  <div>
                    <MyClientIcon
                      iconHandler={iconHandler}
                      type="edit"
                      data={list["client_profile"]["risk_profile"]["input"]}
                      risk_profile={list["client_profile"]["risk_profile"]}
                      client_id={list["client_id"]}
                      client_name={list["client_profile"]["client_name"]}
                      title="edit risk questionnare"
                    >
                      <i className="fa fa-pencil"></i>
                    </MyClientIcon>

                    <MyClientIcon
                      iconHandler={iconHandler}
                      type="new"
                      data={list["client_profile"]["risk_profile"]["input"]}
                      risk_profile={list["client_profile"]["risk_profile"]}
                      client_id={list["client_id"]}
                      client_name={list["client_profile"]["client_name"]}
                      title="start new portfolio"
                    >
                      + P
                    </MyClientIcon>

                    <MyClientIcon
                      iconHandler={iconHandler}
                      type="analyse"
                      data={list["client_profile"]["risk_profile"]["input"]}
                      risk_profile={list["client_profile"]["risk_profile"]}
                      client_id={list["client_id"]}
                      client_name={list["client_profile"]["client_name"]}
                      title="analyse portfolio"
                    >
                      <i className="fa fa-search"></i>
                    </MyClientIcon>
                  </div>
                </div>
                {Object.keys(myClientsDataGroupByClientID).length &&
                openedPortfolios.includes(
                  `${list["scenario_name"]}_${list["client_id"]}`
                ) ? (
                  <div className="myClientTable__content__cell links_holder">
                    {myClientsDataGroupByClientID[list["client_id"]].map(
                      (obj, idx) => (
                        <Link
                          key={idx}
                          to={{
                            pathname: "/dashboard",
                            state: {
                              foo: obj["scenario_id"],
                              heading: obj["scenario_name"],
                              type: obj["scn_status"],
                              subHeading: "",
                              benchmark: obj["scenario_name"],
                              benchmark_name: obj["scenario_name"],
                              // sortedData: [],

                              // subHeading: Data.benchmark_name,
                              // benchmark: Data.benchmark,
                              // benchmark_name: Data.benchmark_name,
                              // sortedData,
                            },
                          }}
                        >
                          <span title={obj["scenario_id"]}>
                            {obj["scenario_name"]}
                          </span>
                        </Link>
                      )
                    )}
                  </div>
                ) : null}
              </Fragment>
            ))}
        </div>
      </div>
    );
  }
}

MyClientTable.propTypes = {
  iconHandler: PropTypes.func.isRequired,
};
export default MyClientTable;



// WEBPACK FOOTER //
// ./src/components/pages/MyClients/myClientTable/MyClientTable.jsx